import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, Button } from '@sgi/gravity';
import { Box } from '@chakra-ui/react';
import { useCallback, useEffect, useState, useRef } from 'react';
import { useMsal } from '@azure/msal-react';
import { logoutRequestB2B } from '../../../..';
export var TIMEOUTS;
(function (TIMEOUTS) {
    TIMEOUTS[TIMEOUTS["IdleTimeout"] = 600000] = "IdleTimeout";
    TIMEOUTS[TIMEOUTS["PopupTimer"] = 300] = "PopupTimer";
    TIMEOUTS[TIMEOUTS["PerSecond"] = 1000] = "PerSecond";
})(TIMEOUTS || (TIMEOUTS = {}));
const domEvents = ['click', 'scroll', 'keypress', 'mousemove', 'load'];
const idleUserAction = {
    staySIgnedIn: 1,
    signedOutNow: 2,
};
const addZero = (seconds) => {
    if (seconds < 10) {
        return '0' + seconds;
    }
    return seconds;
};
export function AppTimeoutModal({ initialOpenValue = false }) {
    const { instance } = useMsal();
    const [open, setOpen] = useState(initialOpenValue);
    const [reset, setReset] = useState(Date.now());
    const [time, setTime] = useState(TIMEOUTS.PopupTimer);
    const [startTimer, setStartTimer] = useState(Date.now());
    const [idleTimeout, setIdleTimeout] = useState(TIMEOUTS.IdleTimeout);
    const [timer, setTimer] = useState({
        seconds: TIMEOUTS.PopupTimer - Math.floor((TIMEOUTS.PopupTimer - 1) / 60) * 60 - 1,
        minutes: Math.floor((TIMEOUTS.PopupTimer - 1) / 60),
    });
    const modalFooter = () => {
        return (_jsxs(_Fragment, { children: [_jsx(Button, { size: "sm", variant: "primary", "data-testid": "idle-user-stay-signed-in", onClick: () => {
                        localStorage.setItem('setIdleUserAction', `${idleUserAction.staySIgnedIn}`);
                        handleIdleUserAction(idleUserAction.staySIgnedIn);
                    }, children: "Stay Signed In" }), _jsx(Button, { ml: 3, size: "sm", variant: "primary", "data-testid": "idle-user-sign-out", onClick: () => {
                        localStorage.setItem('setIdleUserAction', `${idleUserAction.signedOutNow}`);
                        handleIdleUserAction(idleUserAction.signedOutNow);
                    }, children: "Sign Out Now" })] }));
    };
    const resetFn = useCallback(() => {
        if (open === false) {
            const lastActive = Number(localStorage.getItem('lastActive'));
            if (lastActive !== 1) {
                localStorage.setItem('lastActive', `${Date.now()}`);
                setReset(Date.now());
            }
            else {
                setIdleTimeout(TIMEOUTS.PerSecond);
                setReset(Date.now());
            }
        }
    }, []);
    const handleIdleUserAction = (action) => {
        handleClose();
        switch (action) {
            case 1:
                break;
            case 2:
                instance.logoutRedirect(logoutRequestB2B);
                break;
        }
    };
    const handleClose = () => {
        localStorage.setItem('lastActive', `${Date.now()}`);
        setOpen(false);
        setReset(Date.now());
        localStorage.setItem('startCountDownTimer', `0`);
        setIdleTimeout(TIMEOUTS.IdleTimeout);
    };
    const mounted = useRef(0);
    //Countdown timer
    useEffect(() => {
        if (open) {
            if (time <= 1) {
                if (mounted.current) {
                    window.clearTimeout(mounted.current);
                }
                handleClose();
                instance.logoutRedirect({ account: instance.getActiveAccount() });
                return;
            }
            mounted.current = window.setTimeout(() => {
                const lastActive = Number(localStorage.getItem('lastActive'));
                if (lastActive !== 1) {
                    const idleUserAction = Number(localStorage.getItem('setIdleUserAction'));
                    handleIdleUserAction(idleUserAction);
                }
                else {
                    setTime(TIMEOUTS.PopupTimer - Math.floor((Date.now() - startTimer) / 1000));
                    setTimer({
                        seconds: time - Math.floor((time - 1) / 60) * 60 - 1,
                        minutes: Math.floor((time - 1) / 60),
                    });
                }
            }, TIMEOUTS.PerSecond);
        }
        else {
            setTime(TIMEOUTS.PopupTimer);
        }
        return () => {
            if (mounted.current) {
                window.clearTimeout(mounted.current);
            }
        };
    }, [open, time]);
    //Checking the idle users
    useEffect(() => {
        const id = setTimeout(() => {
            const lastActive = Number(localStorage.getItem('lastActive'));
            const countDownTimer = Number(localStorage.getItem('startCountDownTimer'));
            const timeDifference = Date.now() - lastActive;
            if (lastActive === 1 || timeDifference > idleTimeout) {
                localStorage.setItem('lastActive', `1`);
                if (countDownTimer === 0) {
                    localStorage.setItem('startCountDownTimer', `${Date.now()}`);
                    setStartTimer(Date.now());
                }
                else {
                    setStartTimer(countDownTimer);
                }
                setOpen(true);
            }
            else {
                setIdleTimeout(idleTimeout - timeDifference);
                setReset(Date.now());
            }
        }, idleTimeout);
        return clearTimeout.bind(null, id);
    }, [reset]);
    //working with the dom events for active users
    useEffect(() => {
        domEvents.forEach(event => document.addEventListener(event, resetFn));
        return () => {
            domEvents.forEach(event => document.removeEventListener(event, resetFn));
        };
    }, [resetFn]);
    return (_jsx(Box, { "data-testid": "idle-user-timeout-wrapper", children: _jsxs(Modal, { isOpen: open, onClose: () => {
                handleClose();
                localStorage.setItem('setIdleUserAction', `${idleUserAction.staySIgnedIn}`);
            }, title: "Session Expiring", footer: modalFooter(), "data-testid": "idle-user-timeout-popup", children: ["Your session is about to expire in ", ` ${timer.minutes}:${addZero(timer.seconds)}`, " minutes"] }) }));
}
